import { render, staticRenderFns } from "./UserUpcomingVacation.vue?vue&type=template&id=6df01959&"
import script from "./UserUpcomingVacation.vue?vue&type=script&lang=js&"
export * from "./UserUpcomingVacation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports